'use client'
import { useProfile } from '@core/auth'
import { useComponentTranslation } from '@core/i18n'
import { hermesLogger } from '@core/observability'
import { Alert, AlertIcon } from '@core/ui-elements'
import { ROUTES } from '@routes'
import { usePathname, useRouter } from 'next/navigation'
import { useEffect } from 'react'

export function RedirectUnauthUser() {
  const router = useRouter()
  const pathname = usePathname()
  const { user, userPermission } = useProfile()
  const t = useComponentTranslation('MainLayout')

  hermesLogger.warn(
    `[RedirectUnauthUser] User try access ${pathname} with permission ${userPermission}`,
    {
      user,
    }
  )

  useEffect(() => {
    const timeoutId = setTimeout(() => router.replace(ROUTES.home()), 3000)
    return () => {
      clearTimeout(timeoutId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Alert status="error">
      <AlertIcon />
      {t('You dont have access to this functionality')}
    </Alert>
  )
}
